function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var _excluded = ["children", "onSubmit", "scrollToError", "bind", "context", "onError", "beforeVerify", "onVerify", "className", "layout", "dataFields", "ignoreFields", "name", "hideRequiredMark", "labelAlign", "labelCol", "wrapperCol", "readOnly", "colon", "mode"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { toJS, isObservable, observable } from 'mobx';
import { Provider } from 'mobx-react';
import { isObject } from '../sui/utils';
import classNames from 'classnames';
export { default as FormItem } from './FormItem';
/**
 * 表单Form控件
 */

var SuiForm = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiForm, _React$Component);

  var _super = _createSuper(SuiForm);

  function SuiForm(props) {
    var _this;

    _classCallCheck(this, SuiForm);

    _this = _super.call(this, props);
    _this.formMap = void 0;
    _this.disabled = false;
    _this.readOnly = false;
    _this.bind = observable({});

    _this.onChangeValue = function (name, value) {
      _this.props.onChange && _this.props.onChange(_this.getValue(), name, value);
    };

    _this.formMap = new Map();
    _this.name = props.name;

    _this.updateBind(props);

    return _this;
  }

  _createClass(SuiForm, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      this.updateBind(props, true);
      this.updateMode(props, true);
    }
  }, {
    key: "updateMode",
    value: function updateMode(props, receive) {
      var readOnly = props.readOnly,
          disabled = props.disabled,
          mode = props.mode;

      if (mode && /preview/i.test(mode)) {
        readOnly = true;
      }

      if (typeof readOnly === 'boolean' && (!receive || this.props.readOnly !== readOnly)) {
        this.setReadonly(readOnly);
      }

      if (typeof disabled === 'boolean' && (!receive || this.props.disabled !== disabled)) {
        this.setDisabled(disabled);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMode(this.props);
    }
  }, {
    key: "updateBind",
    value: function updateBind(props, update) {
      var bind = props.bind;

      if (isObservable(bind)) {
        this.bind = bind;
      } else {
        if (isObject(bind) && (!update || this.props.bind !== bind)) {
          this.bind = observable(bind);
        }
      }
    }
    /**
     * submit
     */

  }, {
    key: "submit",
    value: function submit(trigger) {
      if (!this.verify(true)) {
        return false;
      }

      var data = this.getValue();

      if (typeof this.props.onSubmit == "function") {
        this.props.onSubmit.call(this, data, trigger);
      }

      return data;
    }
  }, {
    key: "scrollToError",
    value:
    /**
    ** 滚动到第一个错误
     */
    function scrollToError(error) {
      if (!this.props.scrollToError) {
        return;
      }

      var elem = error && error.getRefDOM();

      if (elem) {
        var top;

        if (!elem.getClientRects().length) {
          top = 0;
        } // Get document-relative position by adding viewport scroll to viewport-relative gBCR


        var rect = elem.getBoundingClientRect();
        var win = elem.ownerDocument.defaultView;
        top = rect.top + win.pageYOffset;
        document.body.scrollTop = top;
        document.documentElement.scrollTop = top;
      }
    }
    /**
     * 获取表单项
     */

  }, {
    key: "getItems",
    value: function getItems() {
      var items = [];
      this.formMap.forEach(function (item) {
        item.mounted === false || items.push(item);
      });
      return items;
    }
    /**
     * 获取出错表单项
     */

  }, {
    key: "getErrors",
    value: function getErrors() {
      var errors = [];
      this.getItems().forEach(function (item) {
        if (item.verifyResult && item.verifyResult.hasError) {
          errors.push(item);
        }
      });
      return errors.length ? errors : false;
    }
    /**
     * 获取表单数据
     */

  }, {
    key: "getValue",
    value: function getValue() {
      return toJS(this.bind);
    }
    /**
     * 获取表单字段数据
     */

  }, {
    key: "getData",
    value: function getData() {
      var _this$props = this.props,
          dataFields = _this$props.dataFields,
          ignoreFields = _this$props.ignoreFields;
      var data = this.getFieldsValue(dataFields);

      if (ignoreFields && ignoreFields.length) {
        ignoreFields.forEach(function (field) {
          try {
            delete data[field];
          } catch (error) {}
        });
      }

      return toJS(data);
    }
    /**
     * 获取字段值，多字段支持
     * @param {*} item 
     * @param {*} fields 
     * @param {*} values 
     */

  }, {
    key: "_getItemValueByName",
    value: function _getItemValueByName(item, fields, values) {
      if (!item.name) {
        return values;
      }

      var itemName = item.name.trim();
      var names = itemName.split(/[,|]+/);

      if (names.length > 1) {
        for (var index = 0; index < names.length; index++) {
          var name = names[index];

          if (!fields || !fields.length || !!~fields.indexOf(name)) {
            values[name] = item.getValue(name, index);
          }
        }
      } else {
        values[itemName] = item.getValue();
      }
    }
    /**
     * 通过name获取一组控件的值
     */

  }, {
    key: "getFieldsValue",
    value: function getFieldsValue(fields) {
      var _this2 = this;

      var values = {};
      this.getItems().forEach(function (item) {
        item.name && typeof item.getValue === "function" && _this2._getItemValueByName(item, fields, values);
      });
      return values;
    }
    /**
     * 通过name获取一个控件的值
     * @param {*} name 
     */

  }, {
    key: "getFieldValue",
    value: function getFieldValue(name) {
      var values = this.getFieldsValue([name]);

      if (values && name) {
        return values[name];
      }

      return;
    }
    /**
     * 校验表单
     */

  }, {
    key: "verify",
    value: function verify() {
      var _this3 = this;

      var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      this.getItems().forEach(function (item) {
        if (typeof _this3.props.beforeVerify === 'function' && false === _this3.props.beforeVerify.call(_this3, item)) {
          item.verifyResult = {};
          item.forceUpdate();
          return;
        }

        item.verify(forceUpdate);
      });
      var errors = this.getErrors();
      var result = errors ? false : true;

      if (typeof this.props.onVerify === "function") {
        this.props.onVerify.call(this, result);
      }

      if (typeof this.props.onError === "function" && !result) {
        this.props.onError.call(this);
      }

      if (errors) {
        if (typeof callback === 'function') {
          callback(errors[0]); // item.getRefDOM() 获取组件窗口DOM
        } else {
          this.scrollToError(errors[0]);
        }
      }

      return result;
    }
    /**
     * 移除错误项的提示
     */

  }, {
    key: "removeErrors",
    value: function removeErrors() {
      var errors = this.getErrors();
      errors && errors.forEach(function (item) {
        item.verifyResult = {};
        item.forceUpdate();
      });
    }
  }, {
    key: "hasSuccess",
    value: function hasSuccess() {
      this.formMap.forEach(function (item) {
        if (item.verifyResult && !item.verifyResult.hasError) {
          item.verifyResult = {
            hasSuccess: true
          };
          item.forceUpdate();
        }
      });
    }
    /**
     * 设置禁用模式
     */

  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      var _disabled = typeof disabled === "boolean" ? disabled : !this.disabled;

      this.disabled = _disabled;
      this.getItems().forEach(function (item) {
        if (item.attrs.disabled === _disabled) {
          return;
        }

        if (_disabled) {
          item.__formDisabled = item.attrs.disabled || false;
          item.attrs.disabled = true;
        } else {
          item.attrs.disabled = item.__formDisabled;
        }
      });
      return _disabled;
    }
    /**
     * 设置只读
     */

  }, {
    key: "setReadonly",
    value: function setReadonly(readOnly) {
      var _readOnly = typeof readOnly === "boolean" ? readOnly : !this.readOnly;

      this.readOnly = _readOnly;
      this.getItems().forEach(function (item) {
        if (item.attrs.readOnly === _readOnly) {
          return;
        }

        if (_readOnly) {
          item.__formReadonly = item.attrs.readOnly || false;
          item.attrs.readOnly = true;
        } else {
          item.attrs.readOnly = item.__formReadonly;
        }
      });
      return _readOnly;
    }
    /**
     * 重置
     */

  }, {
    key: "reset",
    value: function reset(force) {
      this.getItems().forEach(function (item) {
        item.reset && item.reset(force);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      console.log("===== render form =====");

      var _this$props2 = this.props,
          children = _this$props2.children,
          onSubmit = _this$props2.onSubmit,
          scrollToError = _this$props2.scrollToError,
          bind = _this$props2.bind,
          context = _this$props2.context,
          onError = _this$props2.onError,
          beforeVerify = _this$props2.beforeVerify,
          onVerify = _this$props2.onVerify,
          className = _this$props2.className,
          _this$props2$layout = _this$props2.layout,
          layout = _this$props2$layout === void 0 ? 'horizontal' : _this$props2$layout,
          dataFields = _this$props2.dataFields,
          ignoreFields = _this$props2.ignoreFields,
          name = _this$props2.name,
          _this$props2$hideRequ = _this$props2.hideRequiredMark,
          hideRequiredMark = _this$props2$hideRequ === void 0 ? false : _this$props2$hideRequ,
          _this$props2$labelAli = _this$props2.labelAlign,
          labelAlign = _this$props2$labelAli === void 0 ? 'right' : _this$props2$labelAli,
          labelCol = _this$props2.labelCol,
          wrapperCol = _this$props2.wrapperCol,
          readOnly = _this$props2.readOnly,
          _this$props2$colon = _this$props2.colon,
          colon = _this$props2$colon === void 0 ? true : _this$props2$colon,
          mode = _this$props2.mode,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var stores = {
        context: context,
        bind: this.bind,
        formMap: this.formMap,
        form: this,
        formMode: mode,
        readOnly: readOnly,
        hideRequiredMark: hideRequiredMark,
        labelAlign: labelAlign,
        labelCol: labelCol,
        wrapperCol: wrapperCol,
        colon: colon,
        vertical: layout === 'vertical'
      };
      var cls = classNames(className, 'sui-form ant-form', (_classNames = {}, _defineProperty(_classNames, "ant-form-".concat(layout), !!layout), _defineProperty(_classNames, "ant-form-hide-required-mark", hideRequiredMark), _defineProperty(_classNames, "ant-form-readonly", readOnly), _defineProperty(_classNames, "ant-form-mode-".concat(mode), !!mode), _classNames));
      return /*#__PURE__*/React.createElement(Provider, stores, /*#__PURE__*/React.createElement("div", _extends({
        className: cls
      }, props), children));
    }
  }]);

  return SuiForm;
}(React.Component);

SuiForm.defaultProps = {
  scrollToError: true
};
export default SuiForm;